import React, { useEffect } from 'react';
import { UserDataEntry } from './CompanyContactPersonOverview';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	PaginationState,
	RowData,
	SortingState,
	useReactTable,
	Table as __Table,
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import useTableState from '../../useTableState';
import { Table as BTable } from 'react-bootstrap';
import TableFooter from '../../Components/TableFooter';
import TableBody from '../../Components/TableBody';
import TableHeader from '../../Components/TableHeader';

const tableName = 'company-contact-person-user-table';

type Props = {
	data: UserDataEntry[];
	columns: AccessorKeyColumnDef<UserDataEntry, unknown>[];
	handleRowClick: (row: RowData) => void;
};
const Table = ({ data, columns, handleRowClick }: Props) => {
	const { t } = useTranslation();
	const { setPageIndex, setPageSize, pageIndex, pageSize } = useTableState(tableName);

	const [pagination, setPagination] = React.useState<PaginationState>({
		pageIndex,
		pageSize,
	});

	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'name',
			desc: false,
		},
	]);

	const [globalFilter, setGlobalFilter] = React.useState<string>('');

	useEffect(() => {
		setPageIndex(pagination.pageIndex);
		setPageSize(pagination.pageSize);
	}, [pagination]);

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		onPaginationChange: setPagination,
		onSortingChange: setSorting,
		enableGlobalFilter: true,
		onGlobalFilterChange: setGlobalFilter,
		state: {
			pagination,
			sorting,
			globalFilter,
		},
	});

	return (
		<>
			<div className="d-flex justify-content-end">
				<div className="d-flex flex-row align-items-center">
					<label className="me-2">{t('table.search')}: </label>
					<input
						className="form-control form-control-sm d-inline-block mt-1"
						value={globalFilter}
						onChange={(e) => {
							setGlobalFilter(e.target.value);
						}}
					/>
				</div>
			</div>
			<BTable responsive hover size={'l'}>
				<TableHeader table={table as __Table<unknown>} />
				<TableBody table={table as __Table<unknown>} handleRowClick={handleRowClick} />
			</BTable>
			<TableFooter table={table as __Table<unknown>} />
		</>
	);
};

export default Table;
